<app-dashboard-admin style="width: inherit;"></app-dashboard-admin>
<section style="background: #f1f1f1; padding-bottom: 4%;">
    <div class="row">
        <div class="col-sm" style="height: 10px;"></div>
        <div class="col-md" style="height: 20px"></div>
    </div>

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb" class="bread-styles">
                    <ol class="breadcrumb bd-background">
                        <li class="breadcrumb-item active" aria-current="page">
                            <a routerLink="dashboardmain-admin"><i class="fa fa-home" aria-hidden="true"></i></a> &nbsp;
                            <span style="cursor: pointer;">Manage Return Tax > <a style="color: #337ab7;font-family: 'pt_sans_captionbold';"> Upload Return Tax</a></span>
                        </li>
                    </ol>
                </nav>
            </div>
        </div>

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 20px"></div>
        </div>


    </div>
    <div class="pie-charts" style="background: white; text-align: center;">
        <h4 style="text-align: center;"> Upload Return Tax </h4>
        <hr>

        <div class="container">
            <div class="form-border">
                <form [formGroup]="form" (ngSubmit)="submit()" class="form-styles">

                    <div class="form-group">
                        <div class="form-row">
                            <div class="col-sm-3">
                                <label for="website" class="control-label">File Type <sup
                                        style="color: red;">*</sup></label>
                            </div>
                            <div class="col-sm-9">
                                <select #mySelected formControlName="website" class="form-control">
                                    <option value="" disabled selected>-----------------Choose File Type ------------------</option>
                                    <option placeholder="Please" [value]="file.user_id" *ngFor="let file of dropdown">
                                        {{file.display_name}}</option>
                                </select>
                                <div *ngIf="f.website.touched && f.website.invalid" class="alert alert-danger">
                                    <div *ngIf="f.website.errors.required">Please Select File Type</div>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="form-row">
                            <div class="com-sm-3 choose-file-style">
                                <label for="file" class="control-label">Choose File <sup
                                        style="color: red;">*</sup></label>
                            </div>
                            <div class="col-sm-9 choose-file-style">
                                <input type="file" (change)="fileProgress($event)" class="form-control"
                                    formControlName="chooseFile">
                            </div>
                        </div>
                        <br>
                        <div class="form-row" style="float: right;">
                            <div class="col-md">
                                <input type="submit" name="submit" id="submit" class="btn btn-danger btn-block"
                                    tabIndex="9" value="Upload" [disabled]="!form.valid">
                            </div>
                            <div class="col-md">
                                <input type="submit" name="submit" id="submit" class="btn btn-secondary btn-block"
                                    tabIndex="9" value="Reset" (click)="reset()">
                            </div>
                        </div>

                    </div>
                    <br>
                    <!-- <div class="form-group">

                        <div class="form-row">
                            <div class="com-sm-3 choose-file-style">
                                <label for="file" class="control-label">Choose File <sup
                                        style="color: red;">*</sup></label>
                            </div>
                            <div class="col-sm-9 choose-file-style">
                                <input type="file" (change)="fileProgress($event)" class="form-control"
                                    formControlName="chooseFile">
                            </div>
                        </div>

                        <div class="form-row" style="float: right;">
                                <div class="col-md">
                                    <input type="submit" name="submit" id="submit" class="btn btn-danger btn-block"
                                        tabIndex="9" value="Upload" [disabled]="!form.valid">
                                </div>
                                <div class="col-md">
                                    <input type="submit" name="submit" id="submit" class="btn btn-secondary btn-block"
                                        tabIndex="9" value="Reset" (click)="reset()">
                                </div>
                            </div>

                    </div> -->

                    <!-- <div class="form-group">
                        <div class="form-row" style="float: right;">
                            <div class="col-md">
                                <input type="submit" name="submit" id="submit" class="btn btn-danger btn-block"
                                    tabIndex="9" value="Upload" [disabled]="!form.valid">
                            </div>
                            <div class="col-md">
                                <input type="submit" name="submit" id="submit" class="btn btn-secondary btn-block"
                                    tabIndex="9" value="Reset" (click)="reset()">
                            </div>
                        </div>
                    </div> -->
                </form>
            </div>
            <!-- <div class="form-group">
                    <div class="form-row reset-styles" style="float: right;">
                            <div class="col-md">
                                <input type="submit" name="submit" id="submit" class="btn btn-secondary btn-block" tabIndex="9"
                                    value="Reset" (click)="reset()">
                            </div>
                        </div>
            </div> -->

        </div>

    </div>
    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white">Loading </p>
    </ngx-spinner>
</section>